// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1d4f24a","image":"_f358dc3","link":"_8ba0524"};